import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const useLocalizedTitle = (titleKey) => {
  const { t, i18n, ready } = useTranslation();

  useEffect(() => {
    if (!ready) return;

    const setTitle = () => {
      document.title = t(titleKey);
    };

    setTitle();
    i18n.on('languageChanged', setTitle);

    // eslint-disable-next-line consistent-return
    return () => {
      i18n.off('languageChanged', setTitle);
    };
  }, [ready, t, titleKey, i18n]);
};

export default useLocalizedTitle;
